// 1750204800000-coerce-offline-lookup-provider.ts
//
// "OFFLINE" was briefly selectable as a profile's Default Lookup Service before
// it had a real adapter, so activating such a profile threw `Service OFFLINE not
// found` and aborted activation. OFFLINE is now a proper offline lookup adapter;
// this one-time, version-tracked migration only rewrites profiles persisted
// during that broken window to the default provider, leaving a profile that
// legitimately selects OFFLINE today untouched.
import { ProfilePouchRepo } from '@/repos/ProfilePouchRepo';
import type { LookupServiceProviderType } from '@/types';
import { pouchLogger } from '@/utils/loggers';

const DEFAULT_LOOKUP_PROVIDER: LookupServiceProviderType = 'HAMDB';

export default async function migrate() {
  const migrationVersion = 1750204800000;
  try {
    const profiles = await ProfilePouchRepo.findAll();
    for (const profile of profiles) {
      if ((profile.lookupService as string) === 'OFFLINE') {
        profile.lookupService = DEFAULT_LOOKUP_PROVIDER;
        await ProfilePouchRepo.update(profile);
        pouchLogger(
          `Coerced profile ${profile._id} lookupService OFFLINE -> ${DEFAULT_LOOKUP_PROVIDER}`
        );
      }
    }
  } catch (err) {
    console.error(`Migration ${migrationVersion} failed:`, err);
    throw err;
  }
}
